var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.item.id))]),_c('td',[_vm._v(_vm._s(_vm.item.created_at))]),_c('td',[_vm._v(_vm._s(_vm.item.count_player))]),_c('td',[_vm._v(_vm._s(_vm.item.bets_sum))]),_c('td',[_vm._v(_vm._s(_vm.item.prizes_sum))]),_c('td',[_vm._v(_vm._s(_vm.item.result))]),_c('td',[_vm._v(_vm._s(_vm.item.total))])])
}
var staticRenderFns = []

export { render, staticRenderFns }